import { render, staticRenderFns } from "./otomatikkapanisfisi.vue?vue&type=template&id=bd1e4ee6&"
import script from "./otomatikkapanisfisi.vue?vue&type=script&lang=js&"
export * from "./otomatikkapanisfisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports